// AUTO-GENERATED by shared/generators/entity_urls_generator.py — do not edit by hand.
// Source: shared/config/modules_entities.config.json

export interface EntityUrlEntry {
  urlTemplate: string;
  urlContextTemplate?: string;
}

export const ENTITY_URL_REGISTRY: Record<string, EntityUrlEntry> = {
  "accounting.account": {
    urlTemplate: "/accounting/accounts/{id}",
  },
  "accounting.bank_deposit": {
    urlTemplate: "/accounting/banking/deposits/{id}",
  },
  "accounting.bill": {
    urlTemplate: "/accounting/bills/{id}",
  },
  "accounting.claim": {
    urlTemplate: "/accounting/claims/{id}",
  },
  "accounting.finance_charge_run": {
    urlTemplate: "/accounting/finance-charges/{id}",
  },
  "accounting.invoice": {
    urlTemplate: "/accounting/invoices/{id}",
  },
  "accounting.journal_entry": {
    urlTemplate: "/accounting/journal-entries/{id}",
  },
  "accounting.payment": {
    urlTemplate: "/accounting/payments/{id}",
  },
  "accounting.payment_run": {
    urlTemplate: "/accounting/payment-runs/{id}",
  },
  "accounting.recurring_template": {
    urlTemplate: "/accounting/recurring",
  },
  "accounting.vendor_statement": {
    urlTemplate: "/accounting/vendor-statements/{id}",
  },
  "accounting_accounts": {
    urlTemplate: "/accounting/accounts/{id}",
  },
  "accounting_bank_deposits": {
    urlTemplate: "/accounting/banking/deposits/{id}",
  },
  "accounting_bills": {
    urlTemplate: "/accounting/bills/{id}",
  },
  "accounting_finance_charge_runs": {
    urlTemplate: "/accounting/finance-charges/{id}",
  },
  "accounting_invoices": {
    urlTemplate: "/accounting/invoices/{id}",
  },
  "accounting_journal_entries": {
    urlTemplate: "/accounting/journal-entries/{id}",
  },
  "accounting_payment_runs": {
    urlTemplate: "/accounting/payment-runs/{id}",
  },
  "accounting_payments": {
    urlTemplate: "/accounting/payments/{id}",
  },
  "accounting_recurring_templates": {
    urlTemplate: "/accounting/recurring",
  },
  "accounting_vendor_statements": {
    urlTemplate: "/accounting/vendor-statements/{id}",
  },
  "accounts": {
    urlTemplate: "/accounting/accounts/{id}",
  },
  "adjustment": {
    urlTemplate: "/inventory/adjustments/{id}",
  },
  "agent_pending_approvals": {
    urlTemplate: "/ai-agents/approvals",
    urlContextTemplate: "/ai-agents/{agent_id}/supervision",
  },
  "agents": {
    urlTemplate: "/ai-agents/{id}",
  },
  "ai_agents.agent": {
    urlTemplate: "/ai-agents/{id}",
  },
  "ai_agents.agent_pending_approval": {
    urlTemplate: "/ai-agents/approvals",
    urlContextTemplate: "/ai-agents/{agent_id}/supervision",
  },
  "ai_chat.chat": {
    urlTemplate: "/ai-chat?session={id}",
  },
  "billing.billing_account": {
    urlTemplate: "/billing/accounts/{id}",
  },
  "billing_account": {
    urlTemplate: "/billing/accounts/{id}",
  },
  "bkr_aggregations": {
    urlTemplate: "/brokerage/aggregations/{id}",
  },
  "bkr_bids": {
    urlTemplate: "/brokerage/bids/{id}",
  },
  "bkr_offer_sheets": {
    urlTemplate: "/brokerage/offer-sheets/{id}",
  },
  "board": {
    urlTemplate: "/tasks/boards/{id}",
  },
  "brokerage.bkr_aggregation": {
    urlTemplate: "/brokerage/aggregations/{id}",
  },
  "brokerage.bkr_bid": {
    urlTemplate: "/brokerage/bids/{id}",
  },
  "brokerage.bkr_offer_sheet": {
    urlTemplate: "/brokerage/offer-sheets/{id}",
  },
  "categories": {
    urlTemplate: "/master-data/categories/{id}",
  },
  "chatbot.chatbot_channel": {
    urlTemplate: "/chatbot/bots",
    urlContextTemplate: "/chatbot/bots/{bot_id}?tab=channels",
  },
  "chatbot.chatbot_conversation": {
    urlTemplate: "/chatbot/inbox?conversation={id}",
  },
  "chatbot_channel": {
    urlTemplate: "/chatbot/bots",
    urlContextTemplate: "/chatbot/bots/{bot_id}?tab=channels",
  },
  "chatbot_conversation": {
    urlTemplate: "/chatbot/inbox?conversation={id}",
  },
  "chats": {
    urlTemplate: "/ai-chat?session={id}",
  },
  "claims": {
    urlTemplate: "/accounting/claims/{id}",
  },
  "companies": {
    urlTemplate: "/master-data/organizations/{id}",
  },
  "company": {
    urlTemplate: "/master-data/organizations/{id}",
  },
  "contacts": {
    urlTemplate: "/master-data/contacts/{id}",
  },
  "contacts_contacts": {
    urlTemplate: "/master-data/contacts/{id}",
  },
  "contacts_organizations": {
    urlTemplate: "/master-data/organizations/{id}",
  },
  "contacts_tiers": {
    urlTemplate: "/master-data/tiers/{id}",
  },
  "contract": {
    urlTemplate: "/contracts/contracts/{id}",
  },
  "contracts.contract": {
    urlTemplate: "/contracts/contracts/{id}",
  },
  "contracts.contract_clause": {
    urlTemplate: "/contracts/clauses/{id}",
  },
  "contracts.contract_template": {
    urlTemplate: "/contracts/templates/{id}",
  },
  "contracts.signature": {
    urlTemplate: "/sign/{token}",
  },
  "ctr_clauses": {
    urlTemplate: "/contracts/clauses/{id}",
  },
  "ctr_contracts": {
    urlTemplate: "/contracts/contracts/{id}",
  },
  "ctr_signatures": {
    urlTemplate: "/sign/{token}",
  },
  "ctr_templates": {
    urlTemplate: "/contracts/templates/{id}",
  },
  "customs_entries": {
    urlTemplate: "/shipments/customs/{id}",
  },
  "deal": {
    urlTemplate: "/pipeline/deals/{id}",
  },
  "employees": {
    urlTemplate: "/people/employees/{id}",
  },
  "exception_fingerprint": {
    urlTemplate: "/software-factory/exceptions?fingerprint={id}",
  },
  "fbpm_business_processes": {
    urlTemplate: "/forms-bpm/business-processes/{id}/edit",
  },
  "fbpm_form_submissions": {
    urlTemplate: "/forms-bpm/submissions/{id}",
  },
  "fbpm_forms": {
    urlTemplate: "/forms-bpm/forms/{id}/edit",
  },
  "fbpm_process_instances": {
    urlTemplate: "/forms-bpm/process-instances/{id}",
  },
  "fbpm_scorecards": {
    urlTemplate: "/forms-bpm/scorecards/{id}",
  },
  "file_management.file": {
    urlTemplate: "/files?file={id}",
  },
  "file_management.folder": {
    urlTemplate: "/files?folder={id}",
  },
  "files": {
    urlTemplate: "/files?file={id}",
  },
  "folders": {
    urlTemplate: "/files?folder={id}",
  },
  "forms_bpm.fbpm_business_process": {
    urlTemplate: "/forms-bpm/business-processes/{id}/edit",
  },
  "forms_bpm.fbpm_form": {
    urlTemplate: "/forms-bpm/forms/{id}/edit",
  },
  "forms_bpm.fbpm_form_submission": {
    urlTemplate: "/forms-bpm/submissions/{id}",
  },
  "forms_bpm.fbpm_process_instance": {
    urlTemplate: "/forms-bpm/process-instances/{id}",
  },
  "forms_bpm.fbpm_scorecard": {
    urlTemplate: "/forms-bpm/scorecards/{id}",
  },
  "forms_bpm_business_processes": {
    urlTemplate: "/forms-bpm/business-processes/{id}/edit",
  },
  "forms_bpm_forms": {
    urlTemplate: "/forms-bpm/forms/{id}/edit",
  },
  "forms_bpm_process_instances": {
    urlTemplate: "/forms-bpm/process-instances/{id}",
  },
  "forms_bpm_scorecards": {
    urlTemplate: "/forms-bpm/scorecards/{id}",
  },
  "frst_agents": {
    urlTemplate: "/shipments/freight-settlements/{id}",
  },
  "frst_settlement_runs": {
    urlTemplate: "/shipments/freight-settlements/runs/{id}",
  },
  "inv_stock_adjustments": {
    urlTemplate: "/inventory/adjustments/{id}",
  },
  "inv_stock_takes": {
    urlTemplate: "/inventory/stock-takes/{id}",
  },
  "inv_stock_transfers": {
    urlTemplate: "/inventory/transfers/{id}",
  },
  "inventory.stock_adjustment": {
    urlTemplate: "/inventory/adjustments/{id}",
  },
  "inventory.stock_take": {
    urlTemplate: "/inventory/stock-takes/{id}",
  },
  "inventory.stock_transfer": {
    urlTemplate: "/inventory/transfers/{id}",
  },
  "item": {
    urlTemplate: "/tasks/tasks/{id}",
    urlContextTemplate: "/tasks/boards/{board_id}?task={id}",
  },
  "marketing.newsletter": {
    urlTemplate: "/marketing/newsletters/{id}",
  },
  "marketing.newsletter_issue": {
    urlTemplate: "/marketing/newsletters/{newsletter_id}/issues/{id}",
  },
  "master_data.company": {
    urlTemplate: "/master-data/organizations/{id}",
  },
  "master_data.contact": {
    urlTemplate: "/master-data/contacts/{id}",
  },
  "master_data.price_list": {
    urlTemplate: "/master-data/price-lists/{id}",
  },
  "master_data.product": {
    urlTemplate: "/master-data/products/{id}",
  },
  "master_data.product_category": {
    urlTemplate: "/master-data/categories/{id}",
  },
  "master_data.tier": {
    urlTemplate: "/master-data/tiers/{id}",
  },
  "messaging.messaging_conversation": {
    urlTemplate: "/messaging?conversation={id}",
  },
  "messaging_conversations": {
    urlTemplate: "/messaging?conversation={id}",
  },
  "mkt_newsletter_issues": {
    urlTemplate: "/marketing/newsletters/{newsletter_id}/issues/{id}",
  },
  "mkt_newsletters": {
    urlTemplate: "/marketing/newsletters/{id}",
  },
  "newsletter": {
    urlTemplate: "/marketing/newsletters/{id}",
  },
  "organizations": {
    urlTemplate: "/master-data/organizations/{id}",
  },
  "people.people_employee": {
    urlTemplate: "/people/employees/{id}",
  },
  "people.people_goal": {
    urlTemplate: "/people/goals/{id}",
  },
  "people.people_one_on_one": {
    urlTemplate: "/people/one-on-ones/{id}",
  },
  "people.people_recognition": {
    urlTemplate: "/people/feedback?tab=recognition&recognition={id}",
  },
  "people.people_review_cycle": {
    urlTemplate: "/people/reviews/{id}",
  },
  "people_employees": {
    urlTemplate: "/people/employees/{id}",
  },
  "people_goals": {
    urlTemplate: "/people/goals/{id}",
  },
  "people_one_on_ones": {
    urlTemplate: "/people/one-on-ones/{id}",
  },
  "people_recognition": {
    urlTemplate: "/people/feedback?tab=recognition&recognition={id}",
  },
  "people_review_cycles": {
    urlTemplate: "/people/reviews/{id}",
  },
  "pipeline.deal": {
    urlTemplate: "/pipeline/deals/{id}",
  },
  "pipeline.pipeline_deal": {
    urlTemplate: "/pipeline/deals/{id}",
  },
  "pipeline.pipeline_outreach_task": {
    urlTemplate: "/pipeline/prospecting/tasks",
  },
  "pipeline.pipeline_sequence": {
    urlTemplate: "/pipeline/prospecting/sequences/{id}",
  },
  "pipeline_deals": {
    urlTemplate: "/pipeline/deals/{id}",
  },
  "pipeline_outreach_tasks": {
    urlTemplate: "/pipeline/prospecting/tasks",
  },
  "pipeline_sequences": {
    urlTemplate: "/pipeline/prospecting/sequences/{id}",
  },
  "price_lists": {
    urlTemplate: "/master-data/price-lists/{id}",
  },
  "proc_goods_receipts": {
    urlTemplate: "/procurement/goods-receipts/{id}",
  },
  "proc_purchase_orders": {
    urlTemplate: "/procurement/purchase-orders/{id}",
  },
  "proc_recurring_po_templates": {
    urlTemplate: "/procurement/recurring-pos",
  },
  "proc_rfqs": {
    urlTemplate: "/procurement/rfqs/{id}",
  },
  "proc_supplier_claims": {
    urlTemplate: "/procurement/supplier-claims",
  },
  "proc_supplier_pis": {
    urlTemplate: "/procurement/supplier-pis/{id}",
  },
  "proc_vendor_returns": {
    urlTemplate: "/procurement/vendor-returns/{id}",
  },
  "procurement.goods_receipt": {
    urlTemplate: "/procurement/goods-receipts/{id}",
  },
  "procurement.purchase_order": {
    urlTemplate: "/procurement/purchase-orders/{id}",
  },
  "procurement.recurring_po_template": {
    urlTemplate: "/procurement/recurring-pos",
  },
  "procurement.rfq": {
    urlTemplate: "/procurement/rfqs/{id}",
  },
  "procurement.supplier_claim": {
    urlTemplate: "/procurement/supplier-claims",
  },
  "procurement.supplier_pi": {
    urlTemplate: "/procurement/supplier-pis/{id}",
  },
  "procurement.vendor_return": {
    urlTemplate: "/procurement/vendor-returns/{id}",
  },
  "product_categories": {
    urlTemplate: "/master-data/categories/{id}",
  },
  "product_price_lists": {
    urlTemplate: "/master-data/price-lists/{id}",
  },
  "products": {
    urlTemplate: "/master-data/products/{id}",
  },
  "products_categories": {
    urlTemplate: "/master-data/categories/{id}",
  },
  "products_price_lists": {
    urlTemplate: "/master-data/price-lists/{id}",
  },
  "products_products": {
    urlTemplate: "/master-data/products/{id}",
  },
  "recruiting.recruiting_application": {
    urlTemplate: "/recruiting/candidates/{candidate_id}?application={id}",
  },
  "recruiting.recruiting_candidate": {
    urlTemplate: "/recruiting/candidates/{id}",
  },
  "recruiting.recruiting_interview": {
    urlTemplate: "/recruiting/interviews/{id}",
  },
  "recruiting.recruiting_job_posting": {
    urlTemplate: "/recruiting/jobs/{id}",
  },
  "recruiting.recruiting_pipeline": {
    urlTemplate: "/recruiting/pipelines/{id}",
  },
  "recruiting_applications": {
    urlTemplate: "/recruiting/candidates/{candidate_id}?application={id}",
  },
  "recruiting_candidates": {
    urlTemplate: "/recruiting/candidates/{id}",
  },
  "recruiting_interviews": {
    urlTemplate: "/recruiting/interviews/{id}",
  },
  "recruiting_job_postings": {
    urlTemplate: "/recruiting/jobs/{id}",
  },
  "recruiting_pipelines": {
    urlTemplate: "/recruiting/pipelines/{id}",
  },
  "sales.order": {
    urlTemplate: "/sales/orders/{id}",
  },
  "sales.sales_commission_plan": {
    urlTemplate: "/sales/commission-plans/{id}",
  },
  "sales.sales_credit_party": {
    urlTemplate: "/sales/credit-parties",
  },
  "sales.sales_customer_account": {
    urlTemplate: "/sales/customers/{id}",
  },
  "sales.sales_order": {
    urlTemplate: "/sales/orders/{id}",
  },
  "sales.sales_order_type": {
    urlTemplate: "/sales/order-types",
  },
  "sales.sales_return": {
    urlTemplate: "/sales/returns/{id}",
  },
  "sales_commission_plans": {
    urlTemplate: "/sales/commission-plans/{id}",
  },
  "sales_credit_parties": {
    urlTemplate: "/sales/credit-parties",
  },
  "sales_customer_accounts": {
    urlTemplate: "/sales/customers/{id}",
  },
  "sales_deals": {
    urlTemplate: "/pipeline/deals/{id}",
  },
  "sales_order": {
    urlTemplate: "/sales/orders/{id}",
  },
  "sales_order_types": {
    urlTemplate: "/sales/order-types",
  },
  "sales_orders": {
    urlTemplate: "/sales/orders/{id}",
  },
  "sales_returns": {
    urlTemplate: "/sales/returns/{id}",
  },
  "sf_changelog_entries": {
    urlTemplate: "/software-factory/changelog/{id}",
  },
  "sf_exception_fingerprints": {
    urlTemplate: "/software-factory/exceptions?fingerprint={id}",
  },
  "sf_initiatives": {
    urlTemplate: "/software-factory/initiatives/{id}",
  },
  "sf_modules": {
    urlTemplate: "/software-factory/modules/{id}",
  },
  "sf_sprints": {
    urlTemplate: "/software-factory/sprints/{id}",
  },
  "sf_work_items": {
    urlTemplate: "/software-factory/work-items/{id}",
  },
  "shared.tenant": {
    urlTemplate: "/sysadmin/tenants/{id}",
  },
  "shipments.cfs_receipt": {
    urlTemplate: "/shipments/cfs/{id}",
  },
  "shipments.consol": {
    urlTemplate: "/shipments/consols/{id}",
  },
  "shipments.customs_entry": {
    urlTemplate: "/shipments/customs/{id}",
  },
  "shipments.freight_agent": {
    urlTemplate: "/shipments/freight-settlements/{id}",
  },
  "shipments.freight_settlement_run": {
    urlTemplate: "/shipments/freight-settlements/runs/{id}",
  },
  "shipments.shipment": {
    urlTemplate: "/shipments/{id}",
  },
  "shipments.shipment_estimate": {
    urlTemplate: "/shipments/estimates/{id}",
  },
  "shp_cfs_receipts": {
    urlTemplate: "/shipments/cfs/{id}",
  },
  "shp_consols": {
    urlTemplate: "/shipments/consols/{id}",
  },
  "shp_shipment_estimates": {
    urlTemplate: "/shipments/estimates/{id}",
  },
  "shp_shipments": {
    urlTemplate: "/shipments/{id}",
  },
  "signature_sign": {
    urlTemplate: "/sign/{token}",
  },
  "software_factory.sf_changelog_entry": {
    urlTemplate: "/software-factory/changelog/{id}",
  },
  "software_factory.sf_exception_fingerprint": {
    urlTemplate: "/software-factory/exceptions?fingerprint={id}",
  },
  "software_factory.sf_initiative": {
    urlTemplate: "/software-factory/initiatives/{id}",
  },
  "software_factory.sf_module": {
    urlTemplate: "/software-factory/modules/{id}",
  },
  "software_factory.sf_sprint": {
    urlTemplate: "/software-factory/sprints/{id}",
  },
  "software_factory.sf_work_item": {
    urlTemplate: "/software-factory/work-items/{id}",
  },
  "sprints": {
    urlTemplate: "/tasks/sprints/{id}",
  },
  "stock_take": {
    urlTemplate: "/inventory/stock-takes/{id}",
  },
  "support.support_ticket": {
    urlTemplate: "/support/tickets/{id}",
  },
  "support.ticket": {
    urlTemplate: "/support/tickets/{id}",
  },
  "support_tickets": {
    urlTemplate: "/support/tickets/{id}",
  },
  "sysadmin.alert": {
    urlTemplate: "/sysadmin/alerts?alert_id={id}",
  },
  "sysadmin_alert": {
    urlTemplate: "/sysadmin/alerts?alert_id={id}",
  },
  "sysadmin_alerts": {
    urlTemplate: "/sysadmin/alerts?alert_id={id}",
  },
  "task": {
    urlTemplate: "/tasks/tasks/{id}",
    urlContextTemplate: "/tasks/boards/{board_id}?task={id}",
  },
  "tasks": {
    urlTemplate: "/tasks/tasks/{id}",
    urlContextTemplate: "/tasks/boards/{board_id}?task={id}",
  },
  "tasks.board": {
    urlTemplate: "/tasks/boards/{id}",
  },
  "tasks.item": {
    urlTemplate: "/tasks/tasks/{id}",
    urlContextTemplate: "/tasks/boards/{board_id}?task={id}",
  },
  "tasks.sprint": {
    urlTemplate: "/tasks/sprints/{id}",
  },
  "tasks.task": {
    urlTemplate: "/tasks/tasks/{id}",
    urlContextTemplate: "/tasks/boards/{board_id}?task={id}",
  },
  "tasks.workspace": {
    urlTemplate: "/tasks/workspaces/{id}",
  },
  "tasks_boards": {
    urlTemplate: "/tasks/boards/{id}",
  },
  "tasks_tasks": {
    urlTemplate: "/tasks/tasks/{id}",
    urlContextTemplate: "/tasks/boards/{board_id}?task={id}",
  },
  "tasks_workspaces": {
    urlTemplate: "/tasks/workspaces/{id}",
  },
  "tenant": {
    urlTemplate: "/sysadmin/tenants/{id}",
  },
  "tenants": {
    urlTemplate: "/sysadmin/tenants/{id}",
  },
  "third_party_services.user_oauth_connection": {
    urlTemplate: "/settings?tab=integrations",
  },
  "ticket": {
    urlTemplate: "/support/tickets/{id}",
  },
  "tickets": {
    urlTemplate: "/support/tickets/{id}",
  },
  "tiers": {
    urlTemplate: "/master-data/tiers/{id}",
  },
  "transfer": {
    urlTemplate: "/inventory/transfers/{id}",
  },
  "user_management.join_request": {
    urlTemplate: "/admin/join-requests",
  },
  "user_management.user": {
    urlTemplate: "/admin/users?user={id}",
  },
  "user_management_join_requests": {
    urlTemplate: "/admin/join-requests",
  },
  "user_oauth_connections": {
    urlTemplate: "/settings?tab=integrations",
  },
  "users": {
    urlTemplate: "/admin/users?user={id}",
  },
  "website_hosting.website": {
    urlTemplate: "/websites/{id}",
  },
  "websites": {
    urlTemplate: "/websites/{id}",
  },
  "workspace": {
    urlTemplate: "/tasks/workspaces/{id}",
  },
};

/** Maps dotted entity type ("module.entity") to its common.json i18n pluralKey.
 * Use with `t(key)` (namespace: common) to get the correct plural display name.
 */
export const ENTITY_PLURAL_KEY_REGISTRY: Record<string, string> = {
  "accounting.account": "entities.accounts",
  "accounting.accounting_audit_log": "entities.accountingAuditLogs",
  "accounting.accounting_document": "entities.accountingDocuments",
  "accounting.bank_account": "entities.bankAccounts",
  "accounting.bank_deposit": "entities.bankDeposits",
  "accounting.bank_deposit_line": "entities.bankDepositLines",
  "accounting.bank_transfer": "entities.bankTransfers",
  "accounting.bill": "entities.bills",
  "accounting.bill_line": "entities.billLines",
  "accounting.claim": "entities.claims",
  "accounting.currency": "entities.currencies",
  "accounting.exchange_rate": "entities.exchangeRates",
  "accounting.finance_charge_run": "entities.financeChargeRuns",
  "accounting.fiscal_period": "entities.fiscalPeriods",
  "accounting.form_filing": "entities.formFilings",
  "accounting.invoice": "entities.invoices",
  "accounting.invoice_line": "entities.invoiceLines",
  "accounting.journal_entry": "entities.journalEntries",
  "accounting.journal_entry_line": "entities.journalEntryLines",
  "accounting.payment": "entities.payments",
  "accounting.payment_allocation": "entities.paymentAllocations",
  "accounting.payment_run": "entities.paymentRuns",
  "accounting.payment_run_bill": "entities.paymentRunBills",
  "accounting.recurring_template": "entities.recurringTemplates",
  "accounting.tax_rate": "entities.taxRates",
  "accounting.tax_rate_component": "entities.taxRateComponents",
  "accounting.vendor_classification_rule": "entities.vendorClassificationRules",
  "accounting.vendor_payment_method": "entities.vendorPaymentMethods",
  "accounting.vendor_statement": "entities.vendorStatements",
  "accounting.vendor_statement_line": "entities.vendorStatementLines",
  "ai_agents.agent": "entities.agents",
  "ai_agents.agent_chat": "entities.agentChats",
  "ai_agents.agent_context_file": "entities.contextFiles",
  "ai_agents.agent_pending_approval": "entities.agentApprovals",
  "ai_chat.chat": "entities.chats",
  "ai_chat.chat_message": "entities.chatMessages",
  "avatars.avatar_session": "entities.avatarSessions",
  "billing.billing_account": "entities.billingAccounts",
  "billing.billing_dispute": "entities.billingDisputes",
  "billing.billing_tier": "entities.billingTiers",
  "billing.billing_wallet": "entities.billingWallets",
  "billing.billing_wallet_ledger": "entities.billingLedgerEntries",
  "brokerage.bkr_aggregation": "entities.brokerageAggregations",
  "brokerage.bkr_bid": "entities.brokerageBids",
  "brokerage.bkr_downstream_distribution": "entities.brokerageDownstreamDistributions",
  "brokerage.bkr_logistics_destination": "entities.brokerageLogisticsDestinations",
  "brokerage.bkr_offer_sheet": "entities.brokerageOfferSheets",
  "brokerage.bkr_offer_sheet_item": "entities.brokerageOfferSheetItems",
  "chatbot.chatbot_bot": "entities.chatbotBots",
  "chatbot.chatbot_channel": "entities.chatbotChannels",
  "chatbot.chatbot_conversation": "entities.chatbotConversations",
  "chatbot.chatbot_flow": "entities.chatbotFlows",
  "chatbot.chatbot_message": "entities.chatbotMessages",
  "coding.coding_task": "entities.codingTasks",
  "contracts.approval": "entities.approvals",
  "contracts.contract": "entities.contracts",
  "contracts.contract_clause": "entities.contractClauses",
  "contracts.contract_party": "entities.contractParties",
  "contracts.contract_playbook": "entities.contractPlaybooks",
  "contracts.contract_playbook_rule": "entities.contractPlaybookRules",
  "contracts.contract_template": "entities.contractTemplates",
  "contracts.contract_type": "entities.contractTypes",
  "contracts.contract_version": "entities.contractVersions",
  "contracts.counterparty_request": "entities.counterpartyRequests",
  "contracts.obligation": "entities.obligations",
  "contracts.signature": "entities.signatures",
  "developer.api_key": "entities.apiKeys",
  "developer.api_usage": "entities.apiUsages",
  "email.email_routing_rule": "entities.emailRoutingRules",
  "email.email_sender_whitelist": "entities.emailSenderWhitelists",
  "email.email_template": "entities.emailTemplates",
  "email.inbound_email": "entities.inboundEmails",
  "email.user_email_address": "entities.userEmailAddresses",
  "file_management.file": "entities.files",
  "file_management.folder": "entities.folders",
  "forms_bpm.fbpm_business_process": "entities.businessProcesses",
  "forms_bpm.fbpm_form": "entities.forms",
  "forms_bpm.fbpm_form_submission": "entities.formSubmissions",
  "forms_bpm.fbpm_process_instance": "entities.processInstances",
  "forms_bpm.fbpm_review": "entities.reviews",
  "forms_bpm.fbpm_scorecard": "entities.scorecards",
  "inventory.stock_adjustment": "entities.stockAdjustments",
  "inventory.stock_issue": "entities.issueStock",
  "inventory.stock_level": "entities.stockLevels",
  "inventory.stock_receipt": "entities.receiveStock",
  "inventory.stock_take": "entities.stockTakes",
  "inventory.stock_transfer": "entities.stockTransfers",
  "inventory.warehouse": "entities.warehouses",
  "marketing.newsletter": "entities.newsletters",
  "marketing.newsletter_issue": "entities.newsletterIssues",
  "marketing.newsletter_subscription": "entities.newsletterSubscriptions",
  "marketing.newsletter_template": "entities.newsletterTemplates",
  "master_data.bundle_item": "entities.bundleItems",
  "master_data.company": "entities.companies",
  "master_data.company_visibility": "entities.companyVisibilities",
  "master_data.contact": "entities.contacts",
  "master_data.contact_visibility": "entities.contactVisibilities",
  "master_data.price_list": "entities.priceLists",
  "master_data.price_list_entry": "entities.priceListEntries",
  "master_data.product": "entities.products",
  "master_data.product_addon": "entities.productAddons",
  "master_data.product_category": "entities.productCategories",
  "master_data.product_configuration": "entities.productConfigurations",
  "master_data.product_configuration_value": "entities.productConfigurationValues",
  "master_data.product_variant": "entities.productVariants",
  "master_data.tier": "entities.tiers",
  "master_data.usage_metric": "entities.usageMetrics",
  "master_data.usage_price_tier": "entities.usagePriceTiers",
  "messaging.messaging_conversation": "entities.conversations",
  "messaging.messaging_message": "entities.messages",
  "messaging.messaging_reminder": "entities.reminders",
  "people.people_employee": "entities.employees",
  "people.people_employee_compensation": "entities.compensations",
  "people.people_employee_contact": "entities.employeeContacts",
  "people.people_employee_job": "entities.employeeJobs",
  "people.people_employee_skill": "entities.employeeSkills",
  "people.people_goal": "entities.goals",
  "people.people_job_title": "entities.jobTitles",
  "people.people_leave_balance": "entities.leaveBalances",
  "people.people_leave_policy": "entities.leavePolicies",
  "people.people_leave_request": "entities.leaveRequests",
  "people.people_onboarding_instance": "entities.onboardingInstances",
  "people.people_onboarding_task": "entities.onboardingTasks",
  "people.people_onboarding_template": "entities.onboardingTemplates",
  "people.people_one_on_one": "entities.oneOnOnes",
  "people.people_recognition": "entities.recognitions",
  "people.people_review": "entities.reviews",
  "people.people_review_cycle": "entities.reviewCycles",
  "pipeline.pipeline_activity": "entities.activities",
  "pipeline.pipeline_deal": "entities.deals",
  "pipeline.pipeline_deal_contact": "entities.dealContacts",
  "pipeline.pipeline_deal_stage_history": "entities.dealStageHistories",
  "pipeline.pipeline_email_template": "entities.emailTemplates",
  "pipeline.pipeline_outreach_task": "entities.outreachTasks",
  "pipeline.pipeline_pipeline": "entities.pipelines",
  "pipeline.pipeline_sequence": "entities.sequences",
  "pipeline.pipeline_sequence_step": "entities.sequenceSteps",
  "pipeline.pipeline_stage": "entities.stages",
  "procurement.goods_receipt": "entities.goodsReceipts",
  "procurement.purchase_order": "entities.purchaseOrders",
  "procurement.purchase_requisition": "entities.purchaseRequisitions",
  "procurement.recurring_po_template": "entities.recurringPoTemplates",
  "procurement.rfq": "entities.rfqs",
  "procurement.supplier_claim": "entities.supplierClaims",
  "procurement.supplier_pi": "entities.supplierPis",
  "procurement.vendor_profile": "entities.vendorProfiles",
  "procurement.vendor_return": "entities.vendorReturns",
  "recruiting.recruiting_activity": "entities.activities",
  "recruiting.recruiting_application": "entities.applications",
  "recruiting.recruiting_application_question": "entities.applicationQuestions",
  "recruiting.recruiting_application_stage_history": "entities.applicationStageHistories",
  "recruiting.recruiting_candidate": "entities.candidates",
  "recruiting.recruiting_department": "entities.departments",
  "recruiting.recruiting_email_template": "entities.emailTemplates",
  "recruiting.recruiting_interview": "entities.interviews",
  "recruiting.recruiting_interview_feedback": "entities.interviewFeedbacks",
  "recruiting.recruiting_interview_participant": "entities.interviewParticipants",
  "recruiting.recruiting_job_board_posting": "entities.jobBoardPostings",
  "recruiting.recruiting_job_interviewer": "entities.interviewers",
  "recruiting.recruiting_job_posting": "entities.jobs",
  "recruiting.recruiting_pipeline": "entities.pipelines",
  "recruiting.recruiting_rejection_reason": "entities.rejectionReasons",
  "recruiting.recruiting_scorecard_template": "entities.scorecardTemplates",
  "recruiting.recruiting_stage": "entities.stages",
  "sales.sales_commission_plan": "entities.salesCommissionPlans",
  "sales.sales_credit_party": "entities.salesCreditParties",
  "sales.sales_customer_account": "entities.salesCustomerAccounts",
  "sales.sales_order": "entities.salesOrders",
  "sales.sales_order_item": "entities.salesOrderItems",
  "sales.sales_order_shipment": "entities.salesOrderShipments",
  "sales.sales_order_type": "entities.salesOrderTypes",
  "sales.sales_return": "entities.salesReturns",
  "shared.audit_log": "entities.auditLogs",
  "shared.session": "entities.sessions",
  "shared.tenant": "entities.tenants",
  "shipments.airline": "entities.airlines",
  "shipments.cfs_receipt": "entities.cfsReceipts",
  "shipments.consol": "entities.consols",
  "shipments.customs_entry": "entities.customsEntries",
  "shipments.freight_agent": "entities.freightAgents",
  "shipments.freight_settlement_run": "entities.freightSettlementRuns",
  "shipments.load_unit_type": "entities.loadUnitTypes",
  "shipments.ocean_carrier": "entities.oceanCarriers",
  "shipments.port_location": "entities.portLocations",
  "shipments.shipment": "entities.shipments",
  "shipments.shipment_estimate": "entities.shipmentEstimates",
  "software_factory.sf_changelog_entry": "entities.sfChangelogEntries",
  "software_factory.sf_exception_fingerprint": "entities.sfExceptionFingerprints",
  "software_factory.sf_initiative": "entities.sfInitiatives",
  "software_factory.sf_module": "entities.sfModules",
  "software_factory.sf_sprint": "entities.sfSprints",
  "software_factory.sf_work_item": "entities.sfWorkItems",
  "support.support_agent_config": "entities.agentConfigs",
  "support.support_business_hours": "entities.businessHours",
  "support.support_canned_response": "entities.cannedResponses",
  "support.support_channel_config": "entities.channelConfigs",
  "support.support_conversation": "entities.supportConversations",
  "support.support_conversation_message": "entities.conversationMessages",
  "support.support_kb_article": "entities.kbArticles",
  "support.support_kb_category": "entities.kbCategories",
  "support.support_routing_rule": "entities.routingRules",
  "support.support_sla_escalation_rule": "entities.slaEscalationRules",
  "support.support_sla_policy": "entities.slaPolicies",
  "support.support_ticket": "entities.supportTickets",
  "support.support_ticket_attachment": "entities.ticketAttachments",
  "support.support_ticket_message": "entities.ticketMessages",
  "sysadmin.alert": "entities.alerts",
  "tasks.board": "entities.boards",
  "tasks.board_column": "entities.boardColumns",
  "tasks.board_member": "entities.boardMembers",
  "tasks.board_view": "entities.boardViews",
  "tasks.sprint": "entities.sprints",
  "tasks.sprint_scope_change": "entities.sprintScopeChanges",
  "tasks.task": "entities.tasks",
  "tasks.task_activity_log": "entities.activityLogs",
  "tasks.task_assignee": "entities.assignees",
  "tasks.task_attachment": "entities.attachments",
  "tasks.task_checklist_item": "entities.checklistItems",
  "tasks.task_column_value": "entities.columnValues",
  "tasks.task_group": "entities.taskGroups",
  "tasks.task_link": "entities.taskLinks",
  "tasks.task_watcher": "entities.watchers",
  "tasks.workspace": "entities.workspaces",
  "tasks.workspace_member": "entities.workspaceMembers",
  "third_party_services.integration_credential": "entities.integrationCredentials",
  "third_party_services.user_oauth_connection": "entities.oauthConnections",
  "user_management.company": "entities.companies",
  "user_management.email_verification_token": "entities.emailVerificationTokens",
  "user_management.join_request": "entities.joinRequests",
  "user_management.office": "entities.offices",
  "user_management.password_reset_token": "entities.passwordResetTokens",
  "user_management.user": "entities.users",
  "user_management.user_group": "entities.groups",
  "user_management.user_group_membership": "entities.groupMemberships",
  "website_hosting.website": "entities.websites",
  "website_hosting.website_asset": "entities.websiteAssets",
  "website_hosting.website_deployment": "entities.websiteDeployments",
  "website_hosting.website_domain": "entities.websiteDomains",
  "website_hosting.website_page": "entities.websitePages",
};

/**
 * Fill `{id}` and any other `{name}` placeholders in a template with values.
 * Returns null if any required placeholder is missing from `values`.
 */
export function fillTemplate(
  template: string,
  values: Record<string, string | undefined>,
): string | null {
  const result = template.replace(/\{([a-zA-Z_][a-zA-Z0-9_]*)\}/g, (_, key) => {
    const v = values[key];
    if (v === undefined || v === null) {
      return '\u0000'; // sentinel for missing
    }
    return encodeURIComponent(v);
  });
  return result.includes('\u0000') ? null : result;
}

/**
 * Resolve a URL for an entity type using the generated registry.
 * Prefers urlContextTemplate when all its placeholders are filled by `values`.
 * Falls back to urlTemplate otherwise. Returns null if no entry or template
 * can be filled.
 */
export function resolveEntityUrl(
  entityType: string,
  values: Record<string, string | undefined>,
): string | null {
  const entry = ENTITY_URL_REGISTRY[entityType];
  if (!entry) return null;
  if (entry.urlContextTemplate) {
    const ctxUrl = fillTemplate(entry.urlContextTemplate, values);
    if (ctxUrl) return ctxUrl;
  }
  return fillTemplate(entry.urlTemplate, values);
}
